import { customElement, property } from 'lit/decorators.js'
import { html } from 'lit'
import { live } from 'lit/directives/live.js'
import { AttributeValue } from 'components/discovery/variant-filter/typing/product-types.js'
import { CSESelect } from '@cloudsuite/mosaic-elements'
import { VariantFilterBase, VariantOption } from 'components/discovery/variant-filter/typing/shared-types.js'

@customElement('csc-variant-filter-dropdown')
export class VariantFilterDropdown extends VariantFilterBase {

  @property({ attribute: false })
  chooseFilterText = ''

  createVariantOption(event: Event): VariantOption {
    const select = event.target as CSESelect

    return {
      key: select.id,
      value: parseInt(select.value) || 0,
    }
  }

  selectedOptionValue(values: AttributeValue[]): string {
    return values.find(value => value.selected)?.id.toString() ?? ''
  }

  override render() {
    return html`
      <cse-form-field>
        <cse-label slot="label">${this.attribute.name}</cse-label>
        <cse-select
          name="${this.attribute.id || ''}"
          id="${this.attribute.id || ''}"
          value="${this.selectedOptionValue(this.attribute.options)}"
          placeholder="${this.chooseFilterText}"
          @change="${(e: Event) => this.callback(this.createVariantOption(e))}"
          required
        >
          ${this.attribute.options.map(option => html`
            <cse-option value=${option.id} ?selected="${live(!!option.selected)}">${option.name}</cse-option>
          `)}
        </cse-select>
      </cse-form-field>
    `
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'csc-variant-filter-dropdown': VariantFilterDropdown
  }
}
